import { useAppStateContext } from '../../AppStateProvider/AppStateProvider';
import { ConnectivitySuccess } from './ConnectivitySuccess/ConnectivitySuccess';
import { ConnectivityFailed } from './ConnectivityFailed/ConnectivityFailed';
import { ConnectionModal } from './ConnectivityModal/ConnectivityModal';
import { useState } from 'react';

export function ConnectivityTest() {
  const { state } = useAppStateContext();
  const [isModalOpen, setIsModalOpen] = useState(false);
  return (
    <>
      <ConnectionModal
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        sipConnectivityUSStatus={state.sipConnectivityUSTestConnected}
        sipConnectivitySAStatus={state.sipConnectivitySATestConnected}
      />
      {state.sipConnectivityUSTestConnected && state.sipConnectivitySATestConnected ? (
        <ConnectivitySuccess openModal={() => setIsModalOpen(true)} />
      ) : (
        <ConnectivityFailed openModal={() => setIsModalOpen(true)} />
      )}
    </>
  );
}
